import { render, staticRenderFns } from "./IndicadorOrganizacionesTipo.vue?vue&type=template&id=34fbee5d&"
import script from "./IndicadorOrganizacionesTipo.vue?vue&type=script&lang=js&"
export * from "./IndicadorOrganizacionesTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports